import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import entityDropdownButtonFactory from '../../../common/lookups/entityDropdownButtonFactory';
import JobComponentCodeItem from '../../../admin/jobs/jobComponentCodeItem';
import withJobActions from './withJobActions';
const ComponentCodeDropdown = entityDropdownButtonFactory('componentCode');
const JobComponentsSubsection = props => {
  const {
    active: {
      components = [],
      id
    },
    onJobAdd,
    onJobChange,
    onJobRemove
  } = props;
  const handleRemove = useCallback(index => onJobRemove('components', index), [onJobRemove]);
  const handleChange = useCallback((index, {
    value,
    name
  }) => onJobChange(`components/${index}/${name}`, value), [onJobChange]);
  const handleAdd = useCallback(componentCode => {
    const defaultData = {
      jobID: id,
      componentCodeID: componentCode !== 'Other' ? componentCode.id : null,
      name: componentCode !== 'Other' ? componentCode.name : ''
    };
    onJobAdd('components', defaultData);
  }, [id, onJobAdd]);
  const componentNames = components.map(c => c.name);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Components"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("section", null, components.map((nextCC, index) => /*#__PURE__*/React.createElement(JobComponentCodeItem, {
    index: index,
    data: nextCC,
    key: nextCC.id,
    onChange: handleChange,
    onRemove: handleRemove
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(ComponentCodeDropdown, {
    onAdd: handleAdd,
    names: componentNames,
    enforceUniqueNames: true,
    title: "Add Component",
    includeOther: true,
    entity: "Component"
  }))));
};
JobComponentsSubsection.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    components: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }).isRequired,
  onJobAdd: PropTypes.func.isRequired,
  onJobChange: PropTypes.func.isRequired,
  onJobRemove: PropTypes.func.isRequired
};
export { JobComponentsSubsection as UncomposedJobComponentsSubsection };
export default withJobActions(JobComponentsSubsection);